<script lang="ts">
  import {currentRoute} from '@/pages/admin/store';
  import {NavItem} from '../types';

  export let navItems: NavItem[] = [];

  const handleOnClick = (href: string) => ($currentRoute = href);
</script>

<nav
  class="fixed left-0 top-0 h-screen w-64 overflow-y-auto border-r border-sermon-gray-300 bg-white text-sermon-base-300"
  aria-label="Main Navigation"
>
  <a href="/" id="logo" class="w-full">
    <img
      alt="sermonshots suite"
      class="h-auto w-full p-4"
      src="https://storage.googleapis.com/sermonshots-homepage/images/image%201.png"
    />
  </a>
  <div class="h-[1px] w-full bg-gray-300"></div>
  <div class="p-4">
    <h1 class="mb-4 text-xl font-bold text-sermon-base-600">Admin Panel</h1>
    <ul class="space-y-2">
      {#each navItems as item}
        <li>
          <a
            href={item.href}
            on:click|preventDefault={() => handleOnClick(item.href)}
            class={`flex items-center gap-x-3 rounded-lg px-4 py-2 transition-colors duration-200 hover:bg-sermon-gray-200 hover:text-sermon-pink focus:text-sermon-pink focus:outline-none
          ${$currentRoute === item.href ? 'text-sermon-pink' : ''}`}
            aria-current={$currentRoute === item.href ? 'page' : undefined}
            role="button"
            tabindex="0"
            on:keydown={e => e.key === 'Enter' && handleOnClick(item.href)}
          >
            <span class={`${item.icon}`} aria-hidden="true" />
            {item.label}
          </a>
        </li>
      {/each}
    </ul>
  </div>
</nav>
